import { IResearchPropertyPath } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const getResearchPropertyHistory = async (
  propertyId: string
): Promise<IResearchPropertyPath[]> => {
  const response = await apiClient.get(
    `/research/properties/${propertyId}/history`
  );

  return response.data;
};
